import { api } from "./api";
import { hrApi } from "./api";

const apiDefinitions = {
  login: async function (payload) {
    return await api.post(`/login`, payload);
  },

  //Leads API Definitions Start
  createLead: async function (token, employeeId, payload) {
    return await api.post(`leads/create_new_lead/${employeeId}`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  getAllLeads: async function (token, offSet, count) {
    const url = `leads/get_all_leads?off_set=${offSet}&count=${count}`;
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return await api.get(url, { headers });
  },

  getMyLeads: async function (
    token,
    offSet,
    count,
    serialNumber,
    searchKey,
    priority,
    status,
    followUpDate
  ) {
    const url = `leads/get_all_leads_by_user_id/${serialNumber}?keyword=${searchKey}&leadPriorityLevelId=${priority}&leadStatus=${status}&offset=${offSet}&pageSize=${count}&followUpDate=${followUpDate}`;
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return await api.get(url, { headers });
  },

  getAllLeadsAndSearch: async function (
    token,
    offSet,
    count,
    searchKey,
    priority,
    status,
    followUpDate,
    courseId,
    assigned
  ) {
    const url = `leads/search/${offSet}/${count}?keyword=${searchKey}&leadPriorityLevelId=${priority}&leadStatus=${status}&followUpDate=${followUpDate}&courseId=${courseId}&assigned=${assigned}`;
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return await api.get(url, { headers });
  },

  getLeadById: async function (token, leadId) {
    return await api.get(`/leads/get_lead/${leadId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  leadAproval: async function (token, leadId, action, rejectBy, note) {
    return await api.post(
      `/leads/assign_leads/${leadId}?action=${action}&approveRejectBy=${rejectBy}&Note=${note}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  },

  getAllPendingLeadsAndSearch: async function (
    token,
    offSet,
    count,
    searchKey,
    priority,
    status,
    followUpDate
  ) {
    const url = `leads/getAll/assign-pending?keyword=${searchKey}&leadPriorityLevelId=${priority}&leadStatus=${status}&followUpDate=${followUpDate}&offset=${offSet}&pageSize=${count}`;
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return await api.get(url, { headers });
  },

  getCoursesByCategoryId: async function (token, categoryId) {
    return await api.get(
      `/leads/courses/get_all_courses/category/${categoryId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  },

  getCourses: async function (token) {
    return await api.get(`/leads/courses/get_all_courses`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  getAllCoursesCategories: async function (token) {
    return await api.get(`/leads/course_categories/get_all_course_categories`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  getAllSourceOfInquiries: async function (token) {
    return await api.get(`/leads/source-of-inquiry`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  updateLead: async function (token, employeeId, leadId, payload) {
    return await api.put(
      `/leads/update_lead/${employeeId}/${leadId}`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  },

  getMarketingEmployeeList: async function () {
    return await hrApi.get(`/get-marketing-list-for-crm`);
  },

  // getNewMarketingEmployeeList: async function () {
  //   return await api.get(`/get-marketing-list-for-crm`);
  // },

  validateNic: async function (token, nic) {
    return await api.get(`/leads/exists_by_nic?nic=${nic}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  //Leads API Definitions End

  //Call Management API Definitions Start
  getCallHistory: async function (token, offSet, count, disposition, days) {
    const url = `contact_history/get_all?off_set=${offSet}&count=${count}&days=${days}&dispositions=${disposition}`;
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return await api.get(url, { headers });
  },

  getMyCallHistory: async function (
    token,
    cnum,
    offSet,
    count,
    dispositions,
    days
  ) {
    const url = `contact_history/byCnum?cnum=${cnum}&page=${offSet}&size=${count}&dispositions=${dispositions}&days=${days}`;
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return await api.get(url, { headers });
  },

  getAllCampaignTypes: async function (token) {
    const url = `campaigns/GetAllCampaignTypes`;
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return await api.get(url, { headers });
  },
  getCampaignSubTypesById: async function (token, categoryId) {
    const url = `campaigns/GetCampaignSubTypes/${categoryId}`;
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return await api.get(url, { headers });
  },

  getAllCampaign: async function (token, searchKey, campaignTypeId, status) {
    const url = `campaigns/SearchCampaigns?keyword=${searchKey}&campaignTypeId=${campaignTypeId}&status=${status}`;
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return await api.get(url, { headers });
  },

  createCampaign: async function (token, employeeId, payload) {
    return await api.post(`/campaigns/CreateCampaign/${employeeId}`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  getAllCampaignCount: async function (token) {
    const url = `campaigns/CountAllCampaigns`;
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return await api.get(url, { headers });
  },

  getAactiveInactiveCount: async function (token) {
    const url = `campaigns/CountActiveAndInactiveCampaigns`;
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return await api.get(url, { headers });
  },
  //Call Management API Definitions End

  //Dashboard API Definitions Start
  getLeadCountByYear: async function (token, year) {
    const url = `leads/get_lead_count_by_year?year=${year}`;
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return await api.get(url, { headers });
  },

  getLeadPercentageBySource: async function (token, days) {
    const url = `/leads/get_lead_percentage_by_source?days=${days}`;
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return await api.get(url, { headers });
  },

  getLeadStatusCount: async function (token, days) {
    const url = `/leads/get_lead_count_by_status_and_date_range?days=${days}`;
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return await api.get(url, { headers });
  },

  getLeadsBySocialMedia: async function (token, days) {
    const url = `/leads/get_lead_count_by_social_media_type?days=${days}`;
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return await api.get(url, { headers });
  },

  getTopFiveCourses: async function (token, days) {
    const url = `/leads/top-five-courses?days=${days}`;
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return await api.get(url, { headers });
  },

  getLeadCount: async function (token) {
    const url = `/leads/count_all_leads`;
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return await api.get(url, { headers });
  },
  getTodayLeadCount: async function (token) {
    const url = `/leads/count_leads_added_today`;
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return await api.get(url, { headers });
  },
  getEnrolledLeadCount: async function (token) {
    const url = `/leads/count_leads_by_enrolled_status`;
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return await api.get(url, { headers });
  },
  getIncompletedLeadCount: async function (token) {
    const url = `/leads/count_incomplete_leads`;
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return await api.get(url, { headers });
  },
  getCampaignStatusCount: async function (token) {
    const url = `/campaigns/GetCampaignStatusCounts`;
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return await api.get(url, { headers });
  },
  getActiveCampaigns: async function (token) {
    const url = `/campaigns/GetAllCampaignNamesAndLeadCounts`;
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return await api.get(url, { headers });
  },
  getCampaignsByChannel: async function (token) {
    const url = `/campaigns/get_campaigns_by_channel`;
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return await api.get(url, { headers });
  },
  getCampainsByMonth: async function (token, year) {
    const url = `/campaigns/get_campaigns_by_month/${year}`;
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return await api.get(url, { headers });
  },
  getLeadVariationByYear: async function (token, year) {
    const url = `/leads/countByCampaignAndMonth?year=${year}`;
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return await api.get(url, { headers });
  },

  //Dashboard API Definitions End

  //Budget API Definitions Start
  createBudget: async function (token, payload) {
    return await api.post(`/budgets/request_new_budget`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
  getApprovedBudgets: async function (token) {
    return await api.get(`/budgets/approved_getAll`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
  getNotApprovedBudgets: async function (token) {
    return await api.get(`/budgets/requested_getAll`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
  getRejectedBudgets: async function (token) {
    return await api.get(`/budgets/rejected_getAll`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
  getJustificationByBudgetID: async function (token, budgetId) {
    return await api.get(`/budgets/get_file_justifications/${budgetId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
  requestTopUpBudget: async function (token, id, payload) {
    return await api.post(
      `/budget/top_up/request_topUp_budget/${id}`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  },
  getTopUpBudgets: async function (token, id) {
    return await api.get(`/budget/top_up/get_all_topUp_budgets/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
  getCampaignsByAnualBudget: async function (token, year) {
    return await api.get(`/campaigns/get_all_campaigns/byYear?year=${year}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
  getBudgetByBudgetId: async function (token, budgetId) {
    return await api.get(`/budgets/get_all_budgets/${budgetId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
  deleteBudget: async function (token, budgetId) {
    return await api.delete(`/budgets/delete_Budget/${budgetId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
  getAllPendingBudgets: async function (token, status) {
    return await api.get(
      `/budgets/get_all_budgets/pending?statusId=${status}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  },

  getAllPendingPresident: async function (token) {
    return await api.get(`/budgets/president_not_approved`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
  getAllPendingFinance: async function (token) {
    return await api.get(`/budgets/finance_not_approved`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
  approveBudget: async function (token, payload) {
    return await api.post(`/budgets/approve_reject_year_budget`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
  getAllPendingTopUpBudgets: async function (token) {
    return await api.get(`/budget/top_up/get_all_topUp_budgets_pending`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
  approveTopUpBudget: async function (token, payload) {
    return await api.post(
      `/budget/top_up/approve_reject_TopUp_budget`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  },
  getBudgetDifference: async function (token, year) {
    return await api.get(`/budgets/campaign_total/difference?year=${year}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  //Campaign API Definitions Start
  getChannelTypes: async function (token, channelId) {
    const url = `/campaigns/GetChannelTypes/${channelId}`;
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return await api.get(url, { headers });
  },

  getChannelSubTypes: async function (token, channelSubTypeId) {
    const url = `/campaigns/GetChannelSubTypes/${channelSubTypeId}`;
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return await api.get(url, { headers });
  },

  getTargetAudience: async function (token) {
    const url = `/campaigns/target-audience/getAll`;
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return await api.get(url, { headers });
  },

  getCampaignDetailsById: async function (token, campaignId) {
    const url = `campaigns/GetCampaign/${campaignId}`;
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return await api.get(url, { headers });
  },

  createExpenses: async function (token, campaignId, payload) {
    return await api.post(
      `/campaigns/apply_campaign_expenses/${campaignId}`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  },

  topUpCampaign: async function (token, campaignId, payload) {
    return await api.post(`/campaignsTopUp/create/${campaignId}`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  getExpensesTypes: async function (token) {
    return await api.get(`/campaigns/get_all_campaigns/expensesTypes`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  getPendingCampaignApprovals: async function (token) {
    return await api.get(`/campaigns/get_all_campaigns/pendingStatus`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  campaignApprovals: async function (
    token,
    campaignId,
    action,
    approveRejectBy,
    note
  ) {
    return await api.post(
      `/campaigns/assign_campaigns/${campaignId}?action=${action}&approveRejectBy=${approveRejectBy}&Note=${note}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  },

  expensesApproval: async function (token, expensesId, approvedBy) {
    return await api.post(
      `/campaigns/expenses/approve/expensesId?approvedBy=${approvedBy}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  },

  expensesRejection: async function (token, expensesId, approvedBy) {
    return await api.post(
      `/campaigns/expenses/reject/expensesId?approvedBy=${approvedBy}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  },

  getTopUpList: async function (token, campaignId) {
    return await api.get(`/campaignsTopUp/get_all/${campaignId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  getExpensesListById: async function (token, campaignId) {
    return await api.get(`/campaigns/get_campaign_expenses/${campaignId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  deleteExpensesById: async function (token, campaignId) {
    return await api.delete(
      `/campaigns/delete_campaign_expenses/${campaignId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  },

  getAllPendingExpenses: async function (token) {
    return await api.get(`/campaigns/get_campaign_expenses/pendingStatus`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  getAllActiveCampaigns: async function (token) {
    return await api.get(`/campaigns/active/getAll`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  getAllCompletedCampaigns: async function (token) {
    return await api.get(`/campaigns/getAllStatus/completed`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  getCampaignSummary: async function (token, campaignId) {
    return await api.get(
      `/campaigns/get_campaign_expenses/summary/${campaignId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  },

  getJustificationForCampaignById: async function (token, expensesId) {
    return await api.get(
      `/campaigns/expenses/file-justifications/${expensesId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  },

  // getAllPendingTopUp: async function (token, expensesId) {
  //   return await api.get(
  //     `/campaigns/expenses/file-justifications/${expensesId}`,
  //     {
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //       },
  //     }
  //   );
  // },

  campaignExpensesApproval: async function (
    token,
    expenseId,
    action,
    approveBy,
    note
  ) {
    return await api.post(
      `/campaigns/expenses/approveReject/${expenseId}?action=${action}&approveRejectBy=${approveBy}&Note=${note}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  },

  deleteTopUp: async function (token, topUpId) {
    return await api.delete(`/campaignsTopUp/delete/${topUpId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  viewTopUpJustification: async function (token, topUpId) {
    return await api.get(`/campaignsTopUp/topUpFileJustifications/${topUpId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  topUpPendingGetAll: async function (token, pendingStatus) {
    return await api.get(`/campaignsTopUp/get_all_pending/${pendingStatus}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  campaignTopUpApproval: async function (
    token,
    topUpId,
    action,
    topUpApproveRejectBy,
    Note
  ) {
    return await api.post(
      `/campaignsTopUp/campaign_budget/${topUpId}?action=${action}&topUpApproveRejectBy=${topUpApproveRejectBy}&Note=${Note}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  },

  //Campaign API Definitions End

  //Notification API Definitions Start
  getNotifications: async function (token, userId, page, size) {
    return await api.get(
      `/notifications/unread?userId=${userId}&page=${page}&size=${size}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  },
  getAllNotifications: async function (token, userID, page, size) {
    return await api.get(
      `/notifications/get_all?userId=${userID}&page=${page}&size=${size}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  },
  markTheNotificationAsRead: async function (token, notificationId, userId) {
    return await api.post(
      `/notifications/markAsRead?notificationId=${notificationId}&userId=${userId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  },
  getUnreadNotificationsCount: async function (token, userId) {
    return await api.get(`/notifications/count_unread/${userId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  getProfilePic: async function (userId) {
    return await hrApi.get(
      `/get-all-employee-detail-by-serial-number/${userId}`,
      {}
    );
  },

  getMarketingList: async function () {
    return await hrApi.get(`/get-marketing-list-for-crm`, {});
  },

  getAssignedCampaignInformation: async function (token, employeeId) {
    return await api.get(`/campaigns/get_campaigns/${employeeId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  getAllSubBudgetsByBudgetId: async function (token, budgetId, page, size) {
    return await api.get(`/subBudgets/${budgetId}?page=${page}&size=${size}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  getSubBudgetByStatus: async function (token, budgetId, status, page, size) {
    return await api.get(
      `/subBudgets/status/${budgetId}/${status}?page=${page}&size=${size}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  },

  getSubBudgetByStatusOnly: async function (token, status, page, size) {
    return await api.get(
      `/subBudgets/status/${status}?page=${page}&size=${size}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  },

  deletePendingSubBudgets: async function (token, subBudgetId) {
    return await api.delete(
      `/subBudgets/deletePendingSubBudget/${subBudgetId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  },

  getSubBudgetDetailsById: async function (token, suBudgetId) {
    return await api.get(`/subBudgets/getAllById/${suBudgetId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  createSubBudget: async function (token, budgetId, subBudgetId, payload) {
    return await api.post(
      `subBudgets/request_new_sub_budget/${budgetId}/${subBudgetId}`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  },

  chequeCollected: async function (token, subBudgetId, chequeCollectedStatus) {
    return await api.post(
      `/subBudgets/collectCheque/${subBudgetId}?isChequeCollected=${chequeCollectedStatus}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  },

  getApprovalForPresident: async function (
    token,
    presidentApprovalStatus,
    page,
    size
  ) {
    return await api.get(
      `/subBudgets/presidentApprovalStatus?isPresidentApproved=${presidentApprovalStatus}&page=${page}&size=${size}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  },

  getApprovalForMarketing: async function (token, statusId, page, size) {
    return await api.get(
      `/subBudgets/statusPending/${statusId}?page=${page}&size=${size}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  },

  getApprovalForFinance: async function (
    token,
    marketingApprovalStatus,
    page,
    size
  ) {
    return await api.get(
      `/subBudgets/financeApprovalStatus?isFinanceApproved=${marketingApprovalStatus}&page=${page}&size=${size}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  },

  getJustificationForSubBudget: async function (token, subBudgetId) {
    return await api.get(`/subBudgets/fileJustifications/${subBudgetId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  approveSubBudgetByPresident: async function (
    token,
    subBudgetId,
    approveStatus
  ) {
    return await api.post(
      `/subBudgets/approveByPresident/${subBudgetId}?isPresidentApproved=${approveStatus}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  },

  approveSubBudgetByFinance: async function (
    token,
    subBudgetId,
    approveStatus,
    payload
  ) {
    return await api.post(
      `/subBudgets/approveByFinance/${subBudgetId}?isFinanceApproved=${approveStatus}`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  },

  rejectSubBudgetByPresident: async function (
    token,
    subBudgetId,
    approveStatus
  ) {
    return await api.post(
      `/subBudgets/approveByPresident/${subBudgetId}?isPresidentApproved=${approveStatus}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  },

  rejectSubBudgetByFinance: async function (token, subBudgetId, approveStatus) {
    return await api.post(
      `/subBudgets/approveByFinance/${subBudgetId}?isFinanceApproved=${approveStatus}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  },

  // approveOrRejectSubBudgetByMarketing: async function (
  //   token,
  //   subBudgetId,
  //   action,
  //   payload
  // ) {
  //   return await api.post(
  //     `/subBudgets/handleSubBudget/${subBudgetId}?action=${action}`,
  //     payload,
  //     {
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //       },
  //     }
  //   );
  // },

  approveOrRejectSubBudgetByMarketing: async function (
    token,
    subBudgetId,
    action,
    payload
  ) {
    return await api.post(
      `/subBudgets/handleSubBudget/${subBudgetId}?action=${action}`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  },

  getAllApprovedSubBudgetsForDropDown: async function (token) {
    const url = `subBudgets/approved/campaignSubBudgets`;
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return await api.get(url, { headers });
  },

  getSubBudgetSummaryById: async function (token, subBudgetId) {
    const url = `subBudgets/subBudgetSummary/${subBudgetId}`;
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return await api.get(url, { headers });
  },

  getSubBudgetTypeSummaryById: async function (token, budgetId) {
    const url = `subBudgets/subBudgetAmount/${budgetId}`;
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return await api.get(url, { headers });
  },

  getSubBudgetSpendings: async function (token, subBudgetId) {
    const url = `subBudgets/summary/${subBudgetId}`;
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return await api.get(url, { headers });
  },

  getCampaignsUnderSubBudget: async function (token, subBudgetId) {
    const url = `campaigns/approvedCampaigns/${subBudgetId}`;
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return await api.get(url, { headers });
  },

  getTopCampaignsByLeads: async function (token) {
    const url = `campaigns/get_top_campaign_by_leads`;
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return await api.get(url, { headers });
  },

  approvingBudgetByFinance: async function (token, budgetId, status, payload) {
    return await api.put(
      `budgets/approve_by_finance/${budgetId}?isFinanceApproved=${status}`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  },

  approvingBudgetByPresident: async function (token, budgetId, status) {
    return await api.put(
      `budgets/approve_by_president/${budgetId}?isPresidentApproved=${status}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  },

  getNotAnsweredByNumber: async function (token, days) {
    return await api.get(`contact_history/top-no-answer?days=${days}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  getAnsweredByNumber: async function (token, days) {
    return await api.get(`contact_history/top-answered?days=${days}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  getCallsByYear: async function (token, year) {
    return await api.get(`contact_history/calls-summary?year=${year}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  getCallStats: async function (token, cnum) {
    return await api.get(`contact_history/count-by-dispositions/${cnum}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  getAllSubTypesByBudgetId: async function (token, budgetId) {
    return await api.get(
      `budgets/budget-with-sub-budgets?budgetId=${budgetId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  },

  subBudgetFundTransfer: async function (token, employeeId, payload) {
    return await api.post(`subBudgets/transfer_amount/${employeeId}`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  subBudgetTypeFundTransfer: async function (token, budgetId, payload) {
    return await api.get(`subBudgets/transferRecords/${budgetId}`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  getPendingSubBudgetFundApproval: async function (token, page, size) {
    return await api.get(
      `subBudgets/pendingTransferList?page=${page}&size=${size}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  },

  approveRejectFundApproval: async function (token, payload) {
    return await api.post(`subBudgets/approve_reject_transfer`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  getCampaignType: async function (token, campaignId) {
    return await api.get(`/campaigns/campaign_type/${campaignId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  getAlumniCampaigns: async function (token) {
    return await api.get(`/campaigns/campaign_type/4`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  getExhibitionCampaigns: async function (token) {
    return await api.get(`/campaigns/campaign_sub_type/90`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  getBroadcastCampaigns: async function (token) {
    return await api.get(`/campaigns/campaign_sub_type/43`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  getGoogleType1Campaigns: async function (token) {
    return await api.get(`/campaigns/campaign_sub_type/2`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  getGoogleType2Campaigns: async function (token) {
    return await api.get(`/campaigns/campaign_sub_type/53`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  getGoogleType3Campaigns: async function (token) {
    return await api.get(`/campaigns/campaign_sub_type/77`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  leadBulkUpload: async function (token, payload, employeeId) {
    return await api.post(`/leads/bulkUpload/${employeeId}`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  leadExport: async function (token, payload) {
    return await api.post(`/leads/export`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  MostSuccessfulCampaign: async function (token) {
    return await api.get(`/campaigns/most-successful`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  leadsPerAmount: async function (token) {
    return await api.get(`/campaigns/leadsPerAmountByYear`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  createStakeholder: async function (token, employeeId, payload) {
    return await api.post(`/contacts/create/${employeeId}`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  getAllStakeholders: async function (token, searchKey, status, page, size) {
    return await api.get(
      `/contacts/search?keyword=${searchKey}&status=${status}&page=${page}&size=${size}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  },

  stakeholderStatus: async function (token, id, status, employeeId) {
    return await api.put(
      `/contacts/${id}/status?status=${status}&userId=${employeeId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  },

  getStakeholderById: async function (token, id) {
    return await api.get(`/contacts/getAllById/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  updateStakeholder: async function (token, id, employeeId, payload) {
    return await api.put(`/contacts/update/${id}/${employeeId}`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  getAllBeneficiaryNames: async function (token) {
    return await api.get(`/contacts/getAllNameAndId`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  getAllBeneficiaryBankDetails: async function (token, id) {
    return await api.get(`/contacts/bank-details/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  createRepresentative: async function (token, employeeId, payload) {
    return await api.post(`/representatives/create/${employeeId}`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  getAllRepresentatives: async function (token, searchKey, status, page, size) {
    return await api.get(
      `/representatives/search?keyword=${searchKey}&status=${status}&offset=${page}&size=${size}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  },

  representativeStatus: async function (token, id, status, userId) {
    return await api.put(
      `/representatives/update-status/${id}?status=${status}&userId=${userId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  },

  getRepresentativeById: async function (token, id) {
    return await api.get(`/representatives/get_all/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  updateRepresentative: async function (token, id, employeeId, payload) {
    return await api.put(
      `/representatives/update/${id}/${employeeId}`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  },

  getAllRepresentativeList: async function (token) {
    return await api.get(`/representatives/active`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  updateCampaign: async function (token, userID, campaignID, payload) {
    return await api.put(
      `/campaigns/UpdateCampaign/${userID}/${campaignID}`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  },

  campaignEvaluation: async function (token, campaignID) {
    return await api.get(`/campaigns/evaluate/${campaignID}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  createRepresentativeLead: async function (token, employeeId, payload) {
    return await api.post(
      `leads/representative/createLead/${employeeId}`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  },
};

export default apiDefinitions;
